// ##### 25-02-05 Komarov
import { Input } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const ConferenceFacilitiesComponent = ({ props }) => {
  const {
    maxLength,
    AddConferenceFacilitiesComments,
    conferenceFacilitiesComments,
  } = props;
  // ##### Komarov 2025-08-05
  const conferenceFacilitiesCommentsMessage = useSelector(state => state.pagesRedux[state.language]?.['Conference facilities'] || '');
  // ##### 23-10-17 Komarov
  const { TextArea } = Input;

  return (
    <div key={uniqueId()} className="form-block-lf">
      <span>{conferenceFacilitiesCommentsMessage}</span>
      <TextArea
        rows={1}
        maxLength={maxLength}
        style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }}
        onChange={AddConferenceFacilitiesComments}
        value={conferenceFacilitiesComments}
      />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default ConferenceFacilitiesComponent;
